<form class="application-form" [formGroup]="form">
    <div class="grid grid-cols-1 gap-6">
        <div>
            <public-registry-search
                label="Sjóðfélagi"
                [searchForPersons]="true"
                [searchForCompanies]="false"
                [enableBatchInput]="false"
                [autoSelectFullSSN]="true"
                [persistSelection]="true"
                [hasError]="applicantSelectionError"
                (onOptionSelected)="onApplicantSelected($event)"
            ></public-registry-search>
            @if (applicantSelectionError) {
                <mat-error>Velja þarf sjóðfélaga úr þjóðskráarleit.</mat-error>
            }
        </div>

        <div>
            <mat-checkbox formControlName="isLSRApplication">Er LSR umsókn</mat-checkbox>
        </div>

        @if (lookupInProgress) {
            <p class="selected-applicant">Sæki sjóði fyrir valinn sjóðfélaga...</p>
        }
        @if (fundsLoaded) {
            <div class="fund-list">
                <h3>Sjóðir</h3>
                @if (availableFunds.length === 0) {
                    <p>Engir sjóðir fundust fyrir valinn sjóðfélaga.</p>
                }
                @for (fund of availableFunds; track fund.fund) {
                    <mat-checkbox [checked]="isFundSelected(fund.fund)" (change)="onFundToggle(fund.fund, $event.checked)">
                        {{ fund.fund }}
                    </mat-checkbox>
                }
            </div>
        }

        @if (form.get('applicantSSN')?.value) {
            <div class="document-section">
                <h3>Undirritað PDF skjal <span class="required-marker">*</span></h3>
                <app-coredata-document-input
                    [documentGroup]="form"
                    [urlControlName]="'signedDocUrl'"
                    [fileNameControlName]="'signedDocName'"
                    [fileNameResolver]="signedDocumentFileNameResolver"
                    (input)="onSignedDocChange()"
                ></app-coredata-document-input>
            </div>
            @if (signedDocError) {
                <mat-error>Nauðsynlegt er að skrá undirritað PDF skjal með gilt Coredata URL.</mat-error>
            }

            <div class="document-section">
                <h3>Viðbótarskjöl</h3>
                @for (doc of additionalDocs.controls; track $index) {
                    <app-coredata-document-input
                        [documentGroup]="doc"
                        [showRemove]="true"
                        (remove)="removeAdditionalDoc($index)"
                        (input)="onAdditionalDocChange()"
                    >
                    </app-coredata-document-input>
                }
                @if (additionalDocError) {
                    <mat-error>Ekki er hægt að nota sama Coredata URL oftar en einu sinni.</mat-error>
                }
                <button mat-stroked-button type="button" (click)="addAdditionalDoc()">
                    <mat-icon>add</mat-icon>
                    Bæta við skjali
                </button>
            </div>
        } @else {
            <p class="selected-applicant">Velja þarf sjóðfélaga áður en hægt er að skrá skjöl.</p>
        }

        <div class="actions">
            <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="submitting || lookupInProgress">
                @if (!submitting) {
                    <span>Skrá umsókn</span>
                }
                @if (submitting) {
                    <mat-progress-spinner [diameter]="22" [mode]="'indeterminate'"></mat-progress-spinner>
                }
            </button>
        </div>
    </div>
</form>
